import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Cipher',
    description: 'A scroll-driven ASCII trading terminal that disintegrates between a spot book, an options chain, and a drawdown profile.',
    url: 'https://modulify.com'
}